var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"go"}},[(_vm.go)?_c('img',{staticClass:"penguin",attrs:{"src":"https://i.imgur.com/lkcElNE.gif"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }